import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";

const url = "api/inventory/base/";

export async function uploadBarcodeExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_barcode_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function createInventoryBarcode(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_inventory_barcode", data, {headers: {"Content-Type": "application/json"}});
    } catch (err: any) {
        return err?.response;
    }
}
